import { UseQueryResult, useQuery } from "@tanstack/react-query";
import TestsListResponse from "../../../models/API/responseModels/testsListResponse.model";
import { useContext } from "react";
import { ApplicationState } from "../../../context/ApplicationStateContext";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";
import OnlineOrderActions from "../../../OnlineOrderActions";

function useTestsList(): UseQueryResult<TestsListResponse, any> {
 const {
  state: { selectedOrganization, selectedPhysician, selectedPathLab,selectedPhysicianData },
 } = useContext(ApplicationState);

 const { authState }: any = useOktaAuth();
 const roles = authState?.accessToken?.claims?.Profile?.roles ?? [];

 return useQuery({
  queryKey: ["testsList", { orgId: selectedOrganization,physicianId: selectedPhysician }],
  queryFn: ({ queryKey }) => {
   const [_key, { orgId }]: any = queryKey;
   const url = `/v1/test-type/get-active-tests-for-organization?organizationId=${orgId}`;
   const orderActions = new OnlineOrderActions(
    selectedOrganization,
    selectedPhysician,
    selectedPhysicianData,
    roles,
    "",
    selectedPathLab,
    undefined,
    authState?.accessToken?.accessToken
   );

   return axiosInstance
    .get(url, {
     headers: {
      Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
     },
     transformResponse: (res) =>
      orderActions.transformTestsListResponse(res, roles),
    })
    .then((res) => {
     return res.data;
    });
  },
  enabled: !!selectedOrganization && !!authState?.accessToken?.accessToken,
 });
}

export default useTestsList;
